<template>
  <WidgetCard title="KORTBESTÄLLNINGAR" subtitle="ATT HANTERA">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'TYP AV KORT', sortable: false, filterable: false, value: 'displayType', width: '200'},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '220', sortable: false},
        {text: 'BESTÄLLT', sortable: false, filterable: false, value: 'createdAt', width: '120'},
        {text: 'BESTÄLLT AV', filterable: false, value: 'createdBy', width: '170'},
        {text: 'STATUS', sortable: false, filterable: false, value: 'printOrderState', width: '160'},
        {text: '', filterable: false, value: 'actions'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="printOrders"
      item-key="id"
      class="clickable"
      :items-per-page="500"
      @click:row="clickPerson"
    >
      <!-- Application name header -->

      <template slot="item.createdAt" slot-scope="props">
        {{ props.item.createdAt | date }}
      </template>
      <template slot="item.createdBy" slot-scope="props">
        <div v-if="props && props.item && props.item.createdBy">
          {{ props.item.createdBy.firstName ? props.item.createdBy.firstName : '' }}
          {{ props.item.createdBy.lastName ? props.item.createdBy.lastName : '' }}
        </div>
      </template>
      <template slot="item.printOrderState" slot-scope="props">
        {{ props.item.printOrderState.name }}
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { mapGetters } from 'vuex'

// @group Widgets
// PrintOrders component
export default {

  name: 'Applications',

  components: {
    WidgetCard
  },

  data: () => ({
    totalRows: 0,
    itemsPerPage: 5,
    printOrders: []
  }),

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.fetchList()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible'])
  },

  created() {
    this.fetchList()
  },

  methods: {
    clickPerson(item) { 
      this.$nextTick(() => this.$router.push({name: 'PrintOrderDetail', params: {id: item.id}}))      
    },
    fetchList() {
      this.criteria = {
        startAt: 0,
        advSearch: this.advSearch,
        pageSize: this.itemsPerPage
      }

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.widgetPrintOrders(params)
        .then(response => {
          //console.log(response.data.rows)
          // Used set criteria location to local store
          // @arg The argument is object representing search criteries
          //this.setCriteriaToLocation('c',this.criteria)
          this.printOrders = response.data.rows?.map(o => {
            return {
              ...o,
              contractType: o.company?.contracttype?.name ?? ''
            }
          })
          this.totalRows = response.data.count
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style scoped>
</style>